
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4C9.238 4 7 6.226 7 8.971c0 1.607 1.039 3.771 1.905 5.505A127.583 127.583 0 0012 20.286s1.494-2.602 3.095-5.81C15.961 12.742 17 10.578 17 8.971 17 6.226 14.762 4 12 4zm0 7.619a2.62 2.62 0 11.001-5.24A2.62 2.62 0 0112 11.62z","fill":"currentColor"}})])
          )
        }
      }
    